<h3 class="title-divider-suche">{{ heading | translate }}</h3>
<ng-form>
  <cap-form-row column-classes="col-md-2,col-md-1">
    <cap-form-control invalidKey="EingabeMussValidesDatumSeinBeispiel" labelKey="Ablaufdatum">
      <input
        (blur)="onTouched()"
        (ngModelChange)="model && (model.ablaufDatum = $event)"
        [ngModel]="model && model.ablaufDatum"
        name="ablaufDatum"
        type="text" />
    </cap-form-control>
  </cap-form-row>
  <cap-form-row column-classes="col-md-1,col-md-4">
    <cap-form-control labelKey="Stichwort">
      <input
        (blur)="onTouched()"
        (ngModelChange)="model && (model.stichwort = $event)"
        [ngModel]="model && model.stichwort"
        name="stichwort"
        type="text" />
    </cap-form-control>
    <cap-form-control column-classes="col-md-2,col-md-4" labelKey="Stichwortzusatz">
      <input
        (blur)="onTouched()"
        (ngModelChange)="model && (model.stichwortZusatz = $event)"
        [ngModel]="model && model.stichwortZusatz"
        name="stichwortZusatz"
        type="text" />
    </cap-form-control>
  </cap-form-row>
</ng-form>
